import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';
import { User, Settings, LogOut, ChevronDown } from 'lucide-react';
import { getUserLogo } from '../services/apiService';

const Header = ({ usuario, onLogout, onNavigate }) => {
  const [open, setOpen] = useState(false);
  const [userLogo, setUserLogo] = useState(null);

  // Cargar logo del usuario al montar el componente y cuando se navega
  useEffect(() => {
    const loadUserLogo = async () => {
      try {
        const response = await getUserLogo();
        if (response.success && response.logo) {
          setUserLogo(response.logo);
        } else {
          setUserLogo(null);
        }
      } catch (error) {
        // Si no hay logo, no es un error crítico
        if (error.message && !error.message.includes('404')) {
          console.warn('No se pudo cargar el logo del usuario:', error);
        }
        setUserLogo(null);
      }
    };
    loadUserLogo();
    
    // Recargar logo cuando se detecta un evento personalizado de actualización
    const handleLogoUpdate = () => {
      loadUserLogo();
    };
    
    window.addEventListener('logoUpdated', handleLogoUpdate);
    return () => window.removeEventListener('logoUpdated', handleLogoUpdate);
  }, []);

  return (
    <header className="sticky top-0 z-40 w-full border-b border-border/50 bg-card/95 backdrop-blur supports-[backdrop-filter]:bg-card/60">
      <div className="container mx-auto px-4 h-16 flex items-center justify-between">
        {/* Logo */}
        <div className="flex items-center gap-3 md:ml-0 ml-14">
          <img 
            src={userLogo || "/favicon-white.svg"} 
            alt="Jarvis" 
            className="h-8 object-contain" 
            onError={(e) => {
              if (userLogo) {
                e.target.src = "/favicon-white.svg";
                setUserLogo(null);
              }
            }}
          />
          <span className="font-semibold text-lg tracking-wide">JARVIS</span>
        </div>

        {/* Perfil */}
        <DropdownMenu open={open} onOpenChange={setOpen}>
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" className="gap-2 h-auto py-2 cursor-pointer">
              <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center">
                <User className="h-4 w-4 text-primary" />
              </div>
              <span className="hidden md:inline-block font-medium">
                {usuario?.nombre || 'Usuario'}
              </span>
              <ChevronDown className="h-4 w-4 text-muted-foreground" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="w-56">
            <DropdownMenuLabel>
              <div className="flex flex-col space-y-1">
                <p className="text-sm font-medium">{usuario?.nombre || 'Usuario'}</p>
                <p className="text-xs text-muted-foreground">{usuario?.email || 'usuario@email.com'}</p>
              </div>
            </DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuItem 
              className="gap-2 cursor-pointer"
              onClick={() => onNavigate && onNavigate('configuracion')}
            >
              <Settings className="h-4 w-4" />
              Ajustes
            </DropdownMenuItem>
            <DropdownMenuSeparator />
            <DropdownMenuItem 
              className="gap-2 text-destructive focus:text-destructive cursor-pointer"
              onClick={onLogout}
            >
              <LogOut className="h-4 w-4" />
              Logout
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </header>
  );
};

export default Header;

